import { styled, alpha } from "@mui/material/styles";
import { Grid, InputBase as MuiInputBase, Toolbar as MuiToolbar } from "@mui/material";

export const Toolbar = styled(MuiToolbar)({
  display: "flex",
  justifyContent: "space-between",
  minHeight: "48px",
});

export const Search = styled(Grid)(({ theme }) => ({
  width: "100%",
  position: "relative",
  marginLeft: 0,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.primary.light, 0.2),
  transition: "all .3s ease",

  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.3),
  },
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

export const InputBase = styled(MuiInputBase)(({ theme }) => ({
  padding: "0 25px 0 0",
  color: "inherit",

  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(1)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },

  "& button": {
    minWidth: "16px",
    padding: "7px 10px",
  },
}));

export const Item = styled(Grid)<{ selected?: boolean }>(
  {
    width: "100%",
    display: "flex",
    borderBottom: "1px solid grey",
    marginBottom: "5px",
    padding: "5px 0",
    justifyContent: "space-between",
    cursor: "pointer",

    "& div": {
      display: "flex",
    },
    "& span:nth-of-type(1)": {
      width: "40%",
    },
    "& span:nth-of-type(2)": {
      width: "35%",
    },
    "& span:nth-of-type(3)": {
      width: "15%",
    },
  },
  ({ selected, theme }) => ({
    ...(selected && { backgroundColor: alpha(theme.palette.primary.light, 0.3) }),
  })
);
